import React from 'react';
import { Link } from 'react-router-dom';

export function itemToLinks(items) {
  return Array.isArray(items) ? items.map(item => createLink(item)) : createLink(items);
}

function createLink(item) {
  if ('string' !== typeof(item) || !item.includes(process.env.REACT_APP_API_PATH)) {
    return <div key={item}>{item}</div>;
  }

  const routeWithoutPrefix = item.replace(process.env.REACT_APP_API_PATH, '');
  const splittedRoute = routeWithoutPrefix.split('/');
  const route = '/' === routeWithoutPrefix[0] ? splittedRoute[1] : splittedRoute[0];

  return <div><Link key={item} to={`/${route}/show/${encodeURIComponent(item)}`}>{item}</Link></div>;
}

export function sleep (ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}


export function getUserRoles (token) {
  let roles = [];
  let base64Url = token.split('.')[1];
  let base64 = base64Url.replace('-', '+').replace('_', '/');
  roles = JSON.parse(window.atob(base64)).roles;
  return roles;
}

export function copyToClipBoard (text) {
  // Create a dummy input to copy the generated code inside it
  let dummy = document.createElement("input");
  // Add it to the document
  document.body.appendChild(dummy);
  // Set its ID
  dummy.setAttribute("id", "dummy_id");
  // output the code in in
  document.getElementById("dummy_id").value=text
  // Select it
  dummy.select();
  // Copy its contents
  document.execCommand("copy");
  // Remove it as its not needed anymore
  document.body.removeChild(dummy);
}



export function sanitizeDomainName(domainName = '') {
  let filteredDomainName = domainName;
  //remove http
  if (filteredDomainName.match('http://')) {
    filteredDomainName = filteredDomainName.split('http://').pop();
  }
  //remove https
  else if (filteredDomainName.match('https://')) {
    filteredDomainName = filteredDomainName.split('https://').pop();
  }
  //remove trailing slash
  filteredDomainName = filteredDomainName.replace(/\/$/, '');

  return filteredDomainName;
}



// WEBPACK FOOTER //
// ./src/utils/helpers.js